export const getDescriptionRows = (text: string, charsPerRow = 80): number => {
  const lines = text.split('\n')
  const totalRows = lines.reduce(
    (acc, line) => acc + Math.ceil((line.length || 1) / charsPerRow),
    0
  )

  return Math.max(3, Math.min(totalRows, 12))
}
